import { Expose, Transform } from 'class-transformer';
import AddressFormError from 'errors/AddressFormError';
import { flattenListErrors } from 'errors/helpers';

export default class AdminPracticeCreationFormError extends AddressFormError {
    cqc_location_id: string[] = []
    email: string[] = []
    first_name: string[] = []
    last_name: string[] = []
    affiliate_code: string[] = []
    marketing_channel: string[] = []
    billing_name: string[] = []
    billing_email: string[] = []
    payment_option: string[] = []
    invoice_due_days: string[] = []
    default_settlement_days: string[] = []
    name: string[] = []
    tz: string[] = []
    parent_company: string[] = []
    @Transform(({ value }) => flattenListErrors(value)) email_for_inquiries: string[] = []
    @Transform(({ value }) => flattenListErrors(value)) email_for_notifications: string[] = []
    @Transform(({ value }) => flattenListErrors(value)) phone_for_inquiries: string[] = []
    @Transform(({ value }) => flattenListErrors(value)) phone_for_notifications: string[] = []
    start_time: string[] = []
    end_time: string[] = []
    lunch_break: string[] = []
    description: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}